import { ENV_CONFIG } from "./env";

export const ASSETS_BASE_URL = ENV_CONFIG.BASE_BUCKET_URL;

export const ICON_PATHS = {
	/** FAVICON */
	LOGO_FAVICON: `${ASSETS_BASE_URL}/logo.svg`,
	WARNING_YELLOW: `${ASSETS_BASE_URL}/warning_yellow.png`,

	ERROR: `${ASSETS_BASE_URL}/error.svg`,
	CHAT: `${ASSETS_BASE_URL}/host/chat.svg`,
	CONFIG: `${ASSETS_BASE_URL}/host/config.svg`,
	POSTS: `${ASSETS_BASE_URL}/host/posts.svg`,
	VE_VIDEOS: `${ASSETS_BASE_URL}/vrVideoIcon.svg`,
	BLOCKED: `${ASSETS_BASE_URL}/host/blocked.svg`,
	PT_MASK: `${ASSETS_BASE_URL}/host/ptMaskIcon.svg`,
	LOGO_MINI: `${ASSETS_BASE_URL}/logoMini.svg`,
	POINTS: `${ASSETS_BASE_URL}/points.svg`,
	SOUND_ON: `${ASSETS_BASE_URL}/soundOn.svg`,
	SOUND_OFF: `${ASSETS_BASE_URL}/soundOff.svg`,
	BELL: `${ASSETS_BASE_URL}/bell.svg`,
	NEWS_DEFAULT: `${ASSETS_BASE_URL}/newsDefault.jpg`,
	PROFILE: `${ASSETS_BASE_URL}/profileIcon.svg`,
	EARNINGS: `${ASSETS_BASE_URL}/earningsIcon.svg`,
	BROADCAST: `${ASSETS_BASE_URL}/broadcastIcon.svg`,
	ATTENTION_RED: `${ASSETS_BASE_URL}/host/attention.svg`,
	PAYMENTS: `${ASSETS_BASE_URL}/dollar_1.svg`,
	PRIVACY: `${ASSETS_BASE_URL}/privacyIcon.svg`,
	NOTES: `${ASSETS_BASE_URL}/notesIcon.svg`,
	INTEGRATIONS: `${ASSETS_BASE_URL}/host/integrationsIcon.svg`,
	FEEDBACK: `${ASSETS_BASE_URL}/feedbackIcon.svg`,
	SUPPORT: `${ASSETS_BASE_URL}/supportIcon.svg`,
	SIGN_OUT: `${ASSETS_BASE_URL}/signOutIcon.svg`,
	BALANCE: `${ASSETS_BASE_URL}/balance.svg`,
	MSG_ICON: `${ASSETS_BASE_URL}/host/msg_icon.svg`,
	INFO: `${ASSETS_BASE_URL}/info.svg`,
	ARROW_DOWN: `${ASSETS_BASE_URL}/arrowDown.svg`,
	WHALE: `${ASSETS_BASE_URL}/whale.svg`,
	STOP: `${ASSETS_BASE_URL}/stop.svg`,
	MUTE: `${ASSETS_BASE_URL}/mute.svg`,
	COVER: `${ASSETS_BASE_URL}/cover.svg`,
	SPY: `${ASSETS_BASE_URL}/spyIcon.svg`,
	PRIVATE_AUDIO_REQUEST: `${ASSETS_BASE_URL}/privateAudioRequestIcon.svg`,
	PRIVATE_CHAT_REQUEST: `${ASSETS_BASE_URL}/privateChatRequestIcon.svg`,
	PRIVATE_CHAT_CANCEL: `${ASSETS_BASE_URL}/privateChatCancelIcon.svg`,
	STOP_PRIVATE: `${ASSETS_BASE_URL}/stopPrivateIcon.svg`,
	PROMO: `${ASSETS_BASE_URL}/promo.svg`,
	REMARK: `${ASSETS_BASE_URL}/remark.svg`,
	PASSWORD_SHOW: `${ASSETS_BASE_URL}/password_show.svg`,
	PASSWORD_HIDE: `${ASSETS_BASE_URL}/password_hide.svg`,
	LOGO: `${ASSETS_BASE_URL}/models_image.svg`,
	PENCIL: `${ASSETS_BASE_URL}/pencil.svg`,
	QUESTION: `${ASSETS_BASE_URL}/question.svg`,
	LINK_BLANK: `${ASSETS_BASE_URL}/link_blank.svg`,
	COPY: `${ASSETS_BASE_URL}/copy_v_t.svg`,
	COPY_OUTLINE: `${ASSETS_BASE_URL}/copy_o_t.svg`,
	REFRESH: `${ASSETS_BASE_URL}/refresh.svg`,
	DOWNLOAD: `${ASSETS_BASE_URL}/download.svg`,
	LINK_ICON: `${ASSETS_BASE_URL}/linkIcon.svg`,

	/** PROFILE */
	CLOSE: `${ASSETS_BASE_URL}/close.svg`,

	/** BIO */
	NAME: `${ASSETS_BASE_URL}/name.svg`,
	AGE: `${ASSETS_BASE_URL}/age.svg`,
	GENDER: `${ASSETS_BASE_URL}/gender.svg`,
	INTERESTS: `${ASSETS_BASE_URL}/interests.svg`,
	LANGUAGES: `${ASSETS_BASE_URL}/languages.svg`,

	/** AGE VERIFICATION */
	AGE_VERIFICATION: `${ASSETS_BASE_URL}/age_verification/ageVerificationIcon.svg`,
	NEEDED_ICON: `${ASSETS_BASE_URL}/age_verification/neededIcon.svg`,
	AWAITING_ICON: `${ASSETS_BASE_URL}/age_verification/awaitingIcon.svg`,
	CONFIRMED_ICON: `${ASSETS_BASE_URL}/age_verification/confirmedIcon.svg`,
	DENIED_ICON: `${ASSETS_BASE_URL}/age_verification/deniedIcon.svg`,

	/** CHAT */
	ARROW_UP: `${ASSETS_BASE_URL}/sendBlue_t.svg`,
	SMILE: `${ASSETS_BASE_URL}/smile.svg`,
	COMPLIMENT: `${ASSETS_BASE_URL}/complimentImage.svg`,
	TOYS_MENU: `${ASSETS_BASE_URL}/toyMenuImage.svg`,
	TIPS: `${ASSETS_BASE_URL}/tipsImage.svg`,
	TIPS_MENU: `${ASSETS_BASE_URL}/tipsMenuImage.svg`,
	WARNING: `${ASSETS_BASE_URL}/warning.svg`,
	DELETE_NOTE: `${ASSETS_BASE_URL}/deleteNote.svg`,
	COPY_NOTE: `${ASSETS_BASE_URL}/copy.svg`,
	WARNING_TRIANGLE: `${ASSETS_BASE_URL}/warning_triangle.svg`,
	CHEVRON: `${ASSETS_BASE_URL}/referrals/chevron.svg`,

	/** REMARKS */
	SEARCH: `${ASSETS_BASE_URL}/search_t.svg`,
	PREVIOUS: `${ASSETS_BASE_URL}/previous.svg`,
	NEXT: `${ASSETS_BASE_URL}/next.svg`,
	SORT: `${ASSETS_BASE_URL}/sort.svg`,

	/** SHOW SETTINGS */
	DIALOG: `${ASSETS_BASE_URL}/dialog.svg`,
	PHONE: `${ASSETS_BASE_URL}/phone.svg`,
	SPY_WHITE: `${ASSETS_BASE_URL}/spy-white.svg`,
	DRAG_CONTROL: `${ASSETS_BASE_URL}/dragControl.svg`,
	PLUS: `${ASSETS_BASE_URL}/plus.svg`,
	DUBLON: `${ASSETS_BASE_URL}/profilemenu-earnings.svg`,
	PRIVATE_LOCK: `${ASSETS_BASE_URL}/privateLock.svg`,
	TRASH: `${ASSETS_BASE_URL}/trash.svg`,

	/** BROADCAST SETTINGS */
	PEN: `${ASSETS_BASE_URL}/pen.svg`,
	DELETE: `${ASSETS_BASE_URL}/delete.svg`,

	/** PAYMENT SETTINGS */
	INFO_RED: `${ASSETS_BASE_URL}/info_red.svg`,

	/** POSTS */
	ADD_A_PHOTO: `${ASSETS_BASE_URL}/add_a_photo.svg`,
	EDIT: `${ASSETS_BASE_URL}/edit.svg`,
	ARROWS: `${ASSETS_BASE_URL}/arrows.svg`,
	CONFIRM: `${ASSETS_BASE_URL}/confirm.svg`,

	/** CREATE ACCOUNT */
	LOGO_BIG: `${ASSETS_BASE_URL}/logo_big.svg`,
	BECOME_STAR: `${ASSETS_BASE_URL}/becomeStar2.jpg`,
	DEFAULT_BANNER: `${ASSETS_BASE_URL}/sign_in_photo.jpeg`,

	/** MESSENGER */
	COIN: `${ASSETS_BASE_URL}/msg/msg_coin.svg`,
	DOTS: `${ASSETS_BASE_URL}/msg/msg_dots.svg`,
	STATUS_ONLINE: `${ASSETS_BASE_URL}/msg/msg_status_online.svg`,
	BANNED: `${ASSETS_BASE_URL}/msg/msg_banned.svg`,
	MUTED: `${ASSETS_BASE_URL}/msg/msg_muted.svg`,
	NO_MESSAGES: `${ASSETS_BASE_URL}/msg/msg_no_messages.svg`,
	DISABLED: `${ASSETS_BASE_URL}/msg/msg_disabled.svg`,
	DISABLED_REGION: `${ASSETS_BASE_URL}/msg/msg_disabled_region.svg`,
	FOLD: `${ASSETS_BASE_URL}/msg/msg_fold.svg`,
	MSG_ERROR: `${ASSETS_BASE_URL}/msg/msg_error.svg`,
	SENT: `${ASSETS_BASE_URL}/msg/msg_sent.svg`,
	READ: `${ASSETS_BASE_URL}/msg/msg_read.svg`,

	/** VR VIDEO */
	ARROW_UP_COLUMN: `${ASSETS_BASE_URL}/vrVideo/arrowUp_column.svg`,
	ARROW_DOWN_COLUMN: `${ASSETS_BASE_URL}/vrVideo/arrowDown_column.svg`,
	NO_VIDEOS: `${ASSETS_BASE_URL}/vrVideo/no_vrVideo.svg`,

	/** GOALS */
	PLAY: `${ASSETS_BASE_URL}/play.svg`,
	GOAL: `${ASSETS_BASE_URL}/goal.svg`,

	/** TOYS */
	HANDY_24: `${ASSETS_BASE_URL}/toys/handy_24.svg`,
	HANDY_16: `${ASSETS_BASE_URL}/toys/handy_16.svg`,
	PROVIDER_IS_OFFLINE: `${ASSETS_BASE_URL}/toys/providerIsOffline.svg`,
	PROVIDER_IS_DISABLED: `${ASSETS_BASE_URL}/toys/providerIsDisabled.svg`,
	HANDY_LOGO_DESKTOP: `${ASSETS_BASE_URL}/toys/handy_logo_desktop.svg`,
	HANDY_DEVICE_IMAGE: `${ASSETS_BASE_URL}/toys/handy_device_image.png`,
	PROVIDER_IS_DISABLED_16: `${ASSETS_BASE_URL}/toys/providerIsDisabled_16.svg`,
	PROVIDER_IS_OFFLINE_16: `${ASSETS_BASE_URL}/toys/providerIsOffline_16.svg`,
	AUTOBLOW_LOGO_DESKTOP: `${ASSETS_BASE_URL}/toys/autoblow_logo_desktop.svg`,
} as const;
